import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

Swiper.use([Scrollbar]);

class ScrollSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.swiper');

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.slidesPerView = 345 / 330;
    this.slidesPerViewPc = 864 / 552;

    this.slider = null;
    this.option = {
      loop: false,
      centeredSlides: false,
      slidesPerView: this.slidesPerView,
      // spaceBetween: 16,
      speed: 600,
          
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev'
      // },
    
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true 
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewPc,
        },
      }
    };

    this.init();
  }

  init() {

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      if (this.slider === null)
        this.slider = new Swiper(this.dom.slider, this.option);

      return;
    } else {
      // console.log('pc');
      if (this.slider !== null)
        this.slider.destroy();
        this.slider = null;

      return;
		}
	}
}

export default ScrollSlides